/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Simple_Successsubscribe1Inputs */

const id_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berhasil berlangganan notifikasi!`)
};

const ms_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berjaya melanggan pemberitahuan!`)
};

const da_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement på notifikationer lykkedes!`)
};

const de_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen erfolgreich abonniert!`)
};

const en_us2_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successfully subscribed to notifications!`)
};

const es_es2_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Suscrito correctamente a las notificaciones!`)
};

const es_mx2_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Suscrito a las notificaciones exitosamente!`)
};

const fil_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matagumpay na naka-subscribe sa mga notipikasyon!`)
};

const fr_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement aux notifications réussi !`)
};

const it_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iscrizione alle notifiche riuscita!`)
};

const hu_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sikeresen feliratkoztál az értesítésekre!`)
};

const nl_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succesvol geabonneerd op meldingen!`)
};

const no_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vellykket abonnement på varsler!`)
};

const pl_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomyślnie subskrybowano powiadomienia!`)
};

const pt_br2_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successfully subscribed to notifications!`)
};

const pt_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações subscritas com sucesso!`)
};

const ro_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te-ai abonat cu succes la notificări!`)
};

const fi_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmoitukset tilattu onnistuneesti!`)
};

const sv_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenumererar på notiser!`)
};

const vi_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đăng ký nhận thông báo thành công!`)
};

const tr_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirimlere başarıyla abone olundu!`)
};

const cs_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úspěšně přihlášeno k oznámením!`)
};

const bg_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Успешно абониране за известия!`)
};

const ru_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Успешно подписались на уведомления!`)
};

const uk_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Успішно підписано на сповіщення!`)
};

const ar_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم الاشتراك في الإشعارات بنجاح!`)
};

const hi_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सफलतापूर्वक सूचनाओं की सदस्यता ली!`)
};

const th_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สมัครรับการแจ้งเตือนสำเร็จ!`)
};

const ja_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知の購読に成功しました！`)
};

const zh_cn2_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successfully subscribed to notifications!`)
};

const zh_hant1_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successfully subscribed to notifications!`)
};

const ko_notifications_simple_successsubscribe1 = /** @type {(inputs: Notifications_Simple_Successsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successfully subscribed to notifications!`)
};

/**
* | output |
* | --- |
* | "Successfully subscribed to notifications!" |
*
* @param {Notifications_Simple_Successsubscribe1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_simple_successsubscribe1 = /** @type {((inputs?: Notifications_Simple_Successsubscribe1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Simple_Successsubscribe1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_simple_successsubscribe1(inputs)
	if (locale === "ms") return ms_notifications_simple_successsubscribe1(inputs)
	if (locale === "da") return da_notifications_simple_successsubscribe1(inputs)
	if (locale === "de") return de_notifications_simple_successsubscribe1(inputs)
	if (locale === "en-US") return en_us2_notifications_simple_successsubscribe1(inputs)
	if (locale === "es-ES") return es_es2_notifications_simple_successsubscribe1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_simple_successsubscribe1(inputs)
	if (locale === "fil") return fil_notifications_simple_successsubscribe1(inputs)
	if (locale === "fr") return fr_notifications_simple_successsubscribe1(inputs)
	if (locale === "it") return it_notifications_simple_successsubscribe1(inputs)
	if (locale === "hu") return hu_notifications_simple_successsubscribe1(inputs)
	if (locale === "nl") return nl_notifications_simple_successsubscribe1(inputs)
	if (locale === "no") return no_notifications_simple_successsubscribe1(inputs)
	if (locale === "pl") return pl_notifications_simple_successsubscribe1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_simple_successsubscribe1(inputs)
	if (locale === "pt") return pt_notifications_simple_successsubscribe1(inputs)
	if (locale === "ro") return ro_notifications_simple_successsubscribe1(inputs)
	if (locale === "fi") return fi_notifications_simple_successsubscribe1(inputs)
	if (locale === "sv") return sv_notifications_simple_successsubscribe1(inputs)
	if (locale === "vi") return vi_notifications_simple_successsubscribe1(inputs)
	if (locale === "tr") return tr_notifications_simple_successsubscribe1(inputs)
	if (locale === "cs") return cs_notifications_simple_successsubscribe1(inputs)
	if (locale === "bg") return bg_notifications_simple_successsubscribe1(inputs)
	if (locale === "ru") return ru_notifications_simple_successsubscribe1(inputs)
	if (locale === "uk") return uk_notifications_simple_successsubscribe1(inputs)
	if (locale === "ar") return ar_notifications_simple_successsubscribe1(inputs)
	if (locale === "hi") return hi_notifications_simple_successsubscribe1(inputs)
	if (locale === "th") return th_notifications_simple_successsubscribe1(inputs)
	if (locale === "ja") return ja_notifications_simple_successsubscribe1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_simple_successsubscribe1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_simple_successsubscribe1(inputs)
	return ko_notifications_simple_successsubscribe1(inputs)
});
export { notifications_simple_successsubscribe1 as "notifications.simple.successSubscribe" }